var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeadset = function SvgIconHeadset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.91 2.737A10 10 0 0 0 12.065 2 10 10 0 0 0 2 12v5.25a2.5 2.5 0 0 0 2.5 2.5H6a2.5 2.5 0 0 0 2.5-2.5V13.5A2.5 2.5 0 0 0 6 11H4.063a8 8 0 0 1 7.995-7h.016a8 8 0 0 1 8.004 7H18.14a2.5 2.5 0 0 0-2.5 2.5v3.75a2.5 2.5 0 0 0 2.5 2.5h1.5q.249 0 .49-.048a2 2 0 0 1-1.99 1.798H12.75a1 1 0 1 0 0 2h5.39a4 4 0 0 0 4-4V12a10 10 0 0 0-6.23-9.263m4.23 14.513V13h-2a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5h1.5a.5.5 0 0 0 .5-.5M4 17.25V13h2a.5.5 0 0 1 .5.5v3.75a.5.5 0 0 1-.5.5H4.5a.5.5 0 0 1-.5-.5",
    clipRule: "evenodd"
  })));
};
export default SvgIconHeadset;